import {ascending, descending} from 'd3-array';

interface ISiblingTableScope extends ng.IScope {
    siblingFactsheetLink: (sibling: any) => string;
    caret: (column) => { hidden: boolean; up: boolean };
    siblings: any[];
    sortedSiblings: any[];
    sortBy(column: string);
    siblingLink(sibling: any): string;
    searchingFor(sibling: any): boolean;
    requestSibling(sibling: any);
    siblingRequested(sibling: any): boolean;
    noFactsheetsFound(sibling: any): boolean;
    factsheetsForSibling(sibling): any[];
    toggleSibling(sibling: any);
    siblingVisible(sibling: any): boolean;
}

export class SiblingTable implements ng.IDirective {
    restrict = 'E';
    scope = {
        siblings: '='
    };
    replace: true;
    template = `<div class="table-responsive w-100" ng-if="!selectedSibling">
    <table class="table table-condensed table-striped w-100" ng-if="sortedSiblings.length">
        <thead>
            <tr>
                <th role="button" ng-click="sortBy('name')">
                    Sibling
                    <span class="caret ng-cloak" ng-class="caret('name')"></span>
                </th>
                <th role="button" ng-click="sortBy('proportion')">
                    Area
                    <span class="caret ng-cloak" ng-class="caret('proportion')"></span>
                </th>
                <th role="button" ng-click="sortBy('proportion')">
                    Proportion
                </th>
            </tr>
        </thead>
        <tbody>
            <tr ng-repeat="sibling in sortedSiblings">
                <td>
                    <a ng-href="{{ siblingFactsheetLink(sibling) }}"
                       target="_blank"
                       lcr-analytics-event='{"category":"SMAP_FACTSHEET", "label":"AREA_QUERY_DOWNLOAD: {{ siblingFactsheetLink(sibling) }}"}'
                       title="Download sibling factsheet PDF">
                        {{ sibling.name }}
                    </a>
                </td>
                <td class="text-right">
                    {{ sibling.area | m2ToHectares }} ha
                </td>
                <td class="text-right">
                    {{ sibling.proportion * 100 | number : 1 }}%
                </td>
            </tr>
        </tbody>
    </table>
</div>`;
    constructor(protected $http: ng.IHttpService, protected ltConfiguration: any) {
    }
    link($scope: ISiblingTableScope, elements: any, attrs: any) {
        let sortBy = 'proportion';
        let sortDirection = descending;

        const update = () => {
            $scope.sortedSiblings = [...((<any> $scope).siblings || [])]
                .sort((a, b) => sortDirection(a[sortBy], b[sortBy]));
        };

        $scope.caret = (column) => {
            return {
                'hidden': sortBy !== column,
                'up': sortDirection === ascending
            }
        }

        const api = this.ltConfiguration.factsheetsAPI || 'https://api-factsheets-smap.landcareresearch.co.nz/';

        $scope.siblingFactsheetLink = (sibling: any) => {
            const url = new URL('reports', api);
            const params = new URLSearchParams();
            params.set('access', 'simple');
            params.set('smapname', sibling.name);
            url.search = `${params}`;

            return url.toString();
        }

        $scope.sortBy = (column: string) => {
            if (sortBy === column) {
                sortDirection = sortDirection === ascending ? descending : ascending;
            }
            sortBy = column;
            update();
        };

        $scope.$watch('siblings', update);

        update();
    };


    static factory() {
        const directive = ($http: ng.IHttpService, ltConfiguration: any) => new SiblingTable($http, ltConfiguration);
        directive.$inject = ['$http', 'ltConfiguration'];
        return directive;
    }
}
